var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShearIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M13.36 7.405c.164-.14.245-.21.275-.292a.33.33 0 0 0 0-.226c-.03-.083-.111-.152-.274-.292l-5.647-4.84c-.28-.24-.42-.36-.54-.364a.33.33 0 0 0-.266.123c-.075.092-.075.277-.075.646v2.863A6.444 6.444 0 0 0 1.5 11.367v.408a7.6 7.6 0 0 1 5.333-2.728v2.793c0 .37 0 .554.075.646.065.08.164.125.267.122.119-.003.259-.123.539-.363z"
})));
export { SvgShearIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/shearIcon.943378e685cb49600780f7bb7571a34b.svg";